type T = string;

export const fromLocalNumber = (p: string): T =>
    p.charAt(0) === "0" ? "+44".concat(p.substr(1)) : p;

const PROPER_PHONE_REGEX = /^\+[1-9][\d]+$/;

export const toValidE164OrNull = (raw: string | null): T | null => {
    if (!raw) {
        return null;
    }
    const hasPlus = raw.trimStart().startsWith("+");
    const digits = raw.replace(/[^\d]/g, "");
    if (digits.length === 0) {
        return null;
    }
    const candidate =
        hasPlus ? `+${digits}`
        : digits.startsWith("00") ? `+${digits.slice(2)}`
        : digits.startsWith("44") ? `+${digits}`
        : fromLocalNumber(digits);
    return PROPER_PHONE_REGEX.test(candidate) ? candidate : null;
};
